import Vue from 'vue'
import * as VueGoogleMaps from 'vue2-google-maps'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify';
import './registerServiceWorker'

Vue.config.productionTip = false

localStorage.apiURL = "https://api.firewatch101.com"
    // localStorage.apiURL = "http://benz.loc:5000"

Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyDSYEDzlADM03ASlBMiqF0SlijoQKP4ek4',
        libraries: 'places',
    }
});

new Vue({
    router,
    vuetify,
    render: h => h(App)
}).$mount('#app')